import type { AuditLogRegisterResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { AuditLogsQueryArgs } from '@risksmart-app/trpc/src/schemas/audit-log';
import type { GetAuditLogsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAuditLogsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

export const useLazyGetAuditLogs = createLazyQueryHook<
  AuditLogsQueryArgs,
  AuditLogRegisterResponseRow[],
  GetAuditLogsQuery
>({
  trpcQuery: (client, args) => client.frontend.auditLog.auditLogs.query(args),
  mapTrpcDataToGraphQL: (data) => ({ audit_log_view: data }),
  graphqlDocument: GetAuditLogsDocument,
});
